import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dayStringName',
})
export class DayStringNamePipe implements PipeTransform {
  constructor() {}

  transform(parm: string): string {
    let feature = moment(parm);
    return feature.format('dddd');
  }
}
